module.exports = __webpack_public_path__ + "static/media/A18040103_10004_4.95641044.jpg";